import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { StyledButton } from "@insite/mobius/Clickable";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

priceStyles.productPrice = {
    price: {
        priceText: { size: 18, color: "secondary" },
        unitOfMeasureText: { size: 18, color: "secondary" },
    },
}

addToListLinkStyles.wrapper = {
    css: css`
        margin-top: 10px;
        text-align: left;
    `,
}

productDetailsImageCarouselStyles.imageCarousel = {
    carouselSlideInner: {
        css: css`
        >${StyledButton}{
            >${LazyImageStyle}{
                min-width: 54px;
                min-height: 38px;
                justify-content: center;
            }
        }
        `
    }
}

descriptionStyles.wrapper = {
    css: css`
        >div{
            color: ${getColor("secondary")};
        }
    `,
}